import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { FinSimulacao } from '../models/fin-simulacao';
import { FinProposta } from '../models/fin-proposta';
import { IGridifyQuery } from 'gridify-client';
import { QueryFilterService } from '../core/services/query-filter-service';
import { Observable } from 'rxjs';
import { OportunidadeVendaCupomGetAllResponse } from '../orcamento/services/pedido-kanban-orcamento.service';
import { FvOportunidadeVendaCupomModel } from '../dominio/fv-oportunidade-venda-cupom-model';
import { PaginatedModel } from '../dominio/paginated-model';
import { GiFinSimulacaoModel } from '../dominio/gi-fin-simulacao-model';
import { SumarioPropostaModel } from '../financiamento/models/sumario-proposta-model';
import { GiFinSimulacaoFinanciadoraModel } from '../dominio/gi-fin-simulacao-financiadora-model';
import { GiFinPropostaModel } from '../dominio/gi-fin-proposta-model';
import { SumarioSimulacaoModel } from '../financiamento/models/sumario-simulacao-model';
import { PropostaFormularioSumarioModel } from '../dominio/proposta-formulario-sumario-model';
import { PerguntaFormularioModel } from '../dominio/pergunta-formulario-model';
import { PropostaFormModel } from '../dominio/proposta-form-model';
import { RespostaFormularioModel } from '../dominio/resposta-formulario-model';
import { FormularioGatewayModel } from '../dominio/formulario-gateway-model';
import { FvOportunidadePropostaModel } from '../dominio/fv-oportunidade-proposta-model';
import { SumarioFinanciadoraModel } from '../financiamento/models/sumario-financiadora-model';
import {
  FinanciadorasResponse,
  ListaFinanciadoraIntegradorResponse,
  ListaSituacoesResponse,
} from './financiamento.services';
import { FinSimulacaoFinanciadoraStatus } from '../dominio/enums';
import { SumarioFormularioFinanciadoraModel } from '../financiamento/models/sumario-formulario-financiadora';

export class GiFinSimulacaoGetAllResponse {
  results: GiFinSimulacaoModel[];
  pagination: PaginatedModel;
}

export class SumarioPropostaResponse {
  result: SumarioPropostaModel;
}

export class DetalheSimulacaoResponse {
  result: GiFinSimulacaoModel;
}

export class FinanciadorasReponse {
  results: GiFinSimulacaoFinanciadoraModel[];
  pagination: PaginatedModel;
}

export class DetalheFinanciadoraResponse {
  result: GiFinSimulacaoFinanciadoraModel;
}

export class PropostaFinanciamentoResponse {
  results: GiFinPropostaModel[];
  pagination: PaginatedModel;
}

export class EnviarFormSimulacaoRequest {
  octopusFormModel: string;
  idFormulario?: number | null;
  respostas?: RespostaFormularioModel[] | null;
}

export class SumarioSimulacaoResponse {
  result: SumarioSimulacaoModel;
}

export class DetalhePropostaResponse {
  result: GiFinPropostaModel;
}

export class PropostaFormularioSumarioResponse {
  result: PropostaFormularioSumarioModel;
}

export class DetalheFormularioManualResponse {
  results: PerguntaFormularioModel[];
  pagination: PaginatedModel;
}

export class ListaFormularioManualResponse {
  results: PropostaFormModel[];
  pagination: PaginatedModel;
}

export class ContratarManualPropostaRequest {
  finalizar: boolean;
  respostas: RespostaFormularioModel[];
}

export class ContratarGatewayPropostaRequest {
  finalizar: boolean;
  model: string;
  idProposta: number;
}

export class BuscarFormularioGatewayResponse {
  result: FormularioGatewayModel;
}

export class ListarPropostasCrmResponse {
  results: FvOportunidadePropostaModel[];
  pagination: PaginatedModel;
}

export class SumarioFinanciadoraResponse {
  result: SumarioFinanciadoraModel;
}

export class AlterarSituacaoFinanciadoraRequest {
  situacao: FinSimulacaoFinanciadoraStatus;
}

export class SumarioFormularioFinanciadoraResponse {
  result: SumarioFormularioFinanciadoraModel;
}

export class FormularioManualResponse {
  results: PerguntaFormularioModel[];
  pagination: PaginatedModel;
}

export class FormularioGatewayResponse {
  result: FormularioGatewayModel;
}

// export class DetalheSimulacaoResponse {
//   result: GiFinSimulacaoModel;
// }

@Injectable({
  providedIn: 'root',
})
export class FinSimulacaoService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService,
    private zone: NgZone,
  ) {}

  salvar(finSimulacao: GiFinSimulacaoModel) {
    return this.http.post<any>(globals.apiUrl + '/api/FinSimulacao/Salvar', finSimulacao);
  }

  consultarSimulacoesPorIdCupom(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarSimulacoesPorIdCupom', {
      params: new HttpParams().set('idCupom', idCupom),
    });
  }

  consultarSimulacaoAtualPorIdCupom(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarSimulacaoAtualPorIdCupom', {
      params: new HttpParams().set('idCupom', idCupom),
    });
  }

  criarNovaSimulacaoAPartirDaUltima(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/CriarNovaSimulacaoAPartirDaUltima', {
      params: new HttpParams().set('idCupom', idCupom),
    });
  }

  criarNovaSimulacaoAPartirDaAtual(idSimulacao) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/CriarNovaSimulacaoAPartirDaAtual', {
      params: new HttpParams().set('idSimulacao', idSimulacao),
    });
  }

  criarNovaSimulacaoAPartirDaUltimaPorIdIntegrador(idIntegrador) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/CriarNovaSimulacaoAPartirDaUltimaPorIdIntegrador', {
      params: new HttpParams().set('idIntegrador', idIntegrador),
    });
  }

  consultarSimulacaoPorId(id: number): Observable<DetalheSimulacaoResponse> {
    return this.http.get<DetalheSimulacaoResponse>(
      globals.apiUrl + `/api/v2/financiamentos/prisma/meus-financiamentos/${id}`,
      {},
    );
  }

  consultarSimulacaoPorIdTarefa(idTarefa): Observable<DetalheSimulacaoResponse> {
    return this.http.get<DetalheSimulacaoResponse>(
      globals.apiUrl + `/api/v2/financiamentos/prisma/celula-credito/${idTarefa}`,
      {},
    );
  }

  consultarIdSimulacaoPorIdTarefa(idTarefa) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarIdSimulacaoPorTarefa', {
      params: new HttpParams().set('idTarefa', idTarefa),
    });
  }

  buscarDadosAdicionais(idTarefa) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarDadosAdicionais', {
      params: new HttpParams().set('idTarefa', idTarefa),
    });
  }

  buscarSumarioSimulacaoCelula(idTarefa: number): Observable<SumarioSimulacaoResponse> {
    return this.http.get<SumarioSimulacaoResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/sumario`,
      {},
    );
  }

  alterarStatusSimulacao(idSimulacao, status, obs) {
    return this.http.post<any>(globals.apiUrl + '/api/FinSimulacao/AlterarStatusSimulacao', {
      idSimulacao,
      status,
      obs,
    });
  }

  alterarStatusSimulacaoPorTarefa(idTarefa: number, mensagem: string | null) {
    return this.http.patch<any>(
      globals.apiUrl + `/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/atualizar-situacao`,
      {
        mensagem,
      },
    );
  }

  consultarLogPorIdSimulacao(idSimulacao) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarLog', {
      params: new HttpParams().set('idSimulacao', idSimulacao),
    });
  }

  consultarPossuiSimulacaoEmAndamento(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/PossuiSimulacaoEmAndamento', {
      params: new HttpParams().set('idCupom', idCupom),
    });
  }

  buscarEnriDadosPorSimulacao(idSimulacao) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarEnriDadosPorSimulacao', {
      params: new HttpParams().set('idSimulacao', idSimulacao),
    });
  }

  buscarPropostas(idSimulacao) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarPropostas', {
      params: new HttpParams().set('idSimulacao', idSimulacao),
    });
  }

  buscarVinculosFinanciadoras(idSimulacao) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarVinculosFinanciadoras', {
      params: new HttpParams().set('idSimulacao', idSimulacao),
    });
  }

  verificarSePedidoPodeSimular(idCupom) {
    return this.http.get<boolean>(globals.apiUrl + '/api/FinSimulacao/VerificarSePedidoPodeSimular', {
      params: new HttpParams().set('idCupom', idCupom),
    });
  }

  possuiVinculosFinanciadorasDisponiveis(idSimulacao) {
    return this.http.get<boolean>(globals.apiUrl + '/api/FinSimulacao/PossuiVinculosFinanciadorasDisponiveis', {
      params: new HttpParams().set('idSimulacao', idSimulacao),
    });
  }

  verificarSeIntegradorPodeSimular(idIntegrador) {
    return this.http.get<boolean>(globals.apiUrl + '/api/FinSimulacao/VerificarSeIntegradorPodeSimular', {
      params: new HttpParams().set('idIntegrador', idIntegrador),
    });
  }

  listarFinanciadorasIntegradorV2(
    idIntegrador: number,
    queryFilter: IGridifyQuery | null = null,
  ): Observable<ListaFinanciadoraIntegradorResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListaFinanciadoraIntegradorResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/resources/integrador/${idIntegrador}/financiadoras`,
      { params: params },
    );
  }

  buscarParcelasCarencias(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarParcelasCarencias', {
      params: new HttpParams().set('idCupom', idCupom),
    });
  }

  possuiSimulacao(idCupom, idIntegrador) {
    let parametros = new HttpParams();

    if (idCupom !== null && idCupom !== undefined) {
      parametros = parametros.set('idCupom', idCupom);
    }

    if (idIntegrador !== null && idIntegrador !== undefined) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/PossuiSimulacao', { params: parametros });
  }

  buscarParcelasCarenciasPorIdIntegrador(idIntegrador) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarParcelasCarenciasPorIdIntegrador', {
      params: new HttpParams().set('idIntegrador', idIntegrador),
    });
  }

  buscarListaStatus(queryFilter: IGridifyQuery | null = null): Observable<ListaSituacoesResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListaSituacoesResponse>(globals.apiUrl + '/api/v2/financiamentos/resources/situacoes', {
      params,
    });
  }

  buscarTodos(queryFilter: IGridifyQuery | null = null): Observable<GiFinSimulacaoGetAllResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<GiFinSimulacaoGetAllResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos`,
      { params },
    );
  }

  alterarSituacaoFinanciadora(idTarefa: number, idFinanciadora: number, request: AlterarSituacaoFinanciadoraRequest) {
    return this.http.patch<any>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras/${idFinanciadora}/situacao`,
      request,
    );
  }

  buscarSumarioProposta(idSimulacao: number, idProposta: number): Observable<SumarioPropostaResponse> {
    return this.http.get<SumarioPropostaResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/propostas/${idProposta}`,
    );
  }

  buscarDetalheSimulacao(idSimulacao: number): Observable<DetalheSimulacaoResponse> {
    return this.http.get<DetalheSimulacaoResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}`,
    );
  }

  buscarFinanciadoras(idSimulacao: number): Observable<FinanciadorasReponse> {
    return this.http.get<FinanciadorasReponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/financiadoras`,
    );
  }

  buscarFinanciadorasPorTarefa(idTarefa: number): Observable<FinanciadorasReponse> {
    return this.http.get<FinanciadorasReponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras`,
    );
  }

  buscarDetalheFinanciadora(idSimulacao: number, idFinanciadora: number): Observable<DetalheFinanciadoraResponse> {
    return this.http.get<DetalheFinanciadoraResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/financiadoras/${idFinanciadora}`,
    );
  }

  buscarSumarioFormularioFinanciadora(
    idSimulacao: number,
    idFinanciadora: number,
  ): Observable<SumarioFormularioFinanciadoraResponse> {
    return this.http.get<SumarioFormularioFinanciadoraResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/financiadoras/${idFinanciadora}/formularios/sumario`,
    );
  }

  buscarSumarioFormularioFinanciadoraFila(
    idTarefa: number,
    idFinanciadora: number,
  ): Observable<SumarioFormularioFinanciadoraResponse> {
    return this.http.get<SumarioFormularioFinanciadoraResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras/${idFinanciadora}/formularios/sumario`,
    );
  }

  buscarFormularioManual(
    idSimulacao: number,
    idFinanciadora: number,
    idFormulario: number,
  ): Observable<FormularioManualResponse> {
    return this.http.get<FormularioManualResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/financiadoras/${idFinanciadora}/formularios/manual/${idFormulario}`,
    );
  }

  buscarFormularioManualFila(
    idTarefa: number,
    idFinanciadora: number,
    idFormulario: number,
  ): Observable<FormularioManualResponse> {
    return this.http.get<FormularioManualResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras/${idFinanciadora}/formularios/manual/${idFormulario}`,
    );
  }

  buscarFormularioGateway(idSimulacao: number, idFinanciadora: number): Observable<FormularioGatewayResponse> {
    return this.http.get<FormularioGatewayResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/financiadoras/${idFinanciadora}/formularios/gateway`,
    );
  }

  buscarFormularioGatewayFila(idTarefa: number, idFinanciadora: number): Observable<FormularioGatewayResponse> {
    return this.http.get<FormularioGatewayResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras/${idFinanciadora}/formularios/gateway`,
    );
  }

  buscarDetalheFinanciadoraPorTarefa(
    idTarefa: number,
    idFinanciadora: number,
  ): Observable<DetalheFinanciadoraResponse> {
    return this.http.get<DetalheFinanciadoraResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idTarefa}/financiadoras/${idFinanciadora}`,
    );
  }

  buscarPropostasV2(
    idSimulacao: number,
    queryFilter: IGridifyQuery | null = null,
  ): Observable<PropostaFinanciamentoResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<PropostaFinanciamentoResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/propostas`,
      { params },
    );
  }

  buscarPropostasV2Tarefa(
    idTarefa: number,
    queryFilter: IGridifyQuery | null = null,
  ): Observable<PropostaFinanciamentoResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<PropostaFinanciamentoResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/propostas`,
      { params },
    );
  }

  alterarVisibilidadeProposta(idTarefa: number, id: number, visivel: boolean) {
    return this.http.patch<any>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/propostas/${id}/visibilidade`,
      { visivel },
    );
  }

  alterarVisibilidadeFinanciadora(idTarefa: number, id: number, visivel: boolean) {
    return this.http.patch<any>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras/${id}/visibilidade`,
      { visivel },
    );
  }

  enviarFormulario(idSimulacao: number, idFinanciadora: number, request: EnviarFormSimulacaoRequest) {
    return this.http.patch<any>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/financiadoras/${idFinanciadora}/solicitar-simulacao`,
      request,
    );
  }

  buscarSumarioFormularioProposta(idProposta: number): Observable<PropostaFormularioSumarioResponse> {
    return this.http.get<PropostaFormularioSumarioResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/resources/propostas/${idProposta}/contratar/sumario`,
    );
  }

  buscarDetalheFormularioManual(idProposta: number, idFormulario: number): Observable<DetalheFormularioManualResponse> {
    return this.http.get<DetalheFormularioManualResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/resources/propostas/${idProposta}/contratar/manual/formularios/${idFormulario}`,
    );
  }

  buscarListaFormularioManual(idProposta: number): Observable<ListaFormularioManualResponse> {
    return this.http.get<ListaFormularioManualResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/resources/propostas/${idProposta}/contratar/manual/formularios`,
    );
  }

  buscarDetalheFormularioGateway(idProposta: number): Observable<BuscarFormularioGatewayResponse> {
    return this.http.get<BuscarFormularioGatewayResponse>(
      globals.apiUrl + `/api/v2/financiamentos/resources/propostas/${idProposta}/contratar/gateway`,
    );
  }

  buscarPropostasCrm(idOportunidade: number): Observable<ListarPropostasCrmResponse> {
    return this.http.get<ListarPropostasCrmResponse>(
      globals.apiUrl + `/api/v2/crm/resources/oportunidades/${idOportunidade}/propostas-financiamento`,
    );
  }

  buscarSumarioPropostaCrm(idProposta: number): Observable<SumarioPropostaResponse> {
    return this.http.get<SumarioPropostaResponse>(
      globals.apiUrl + `/api/v2/financiamentos/resources/propostas/${idProposta}/sumario`,
    );
  }

  eventoAlterarSimulacao(idSimulacao: number): Observable<GiFinSimulacaoModel> {
    return this.http.get<GiFinSimulacaoModel>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/sse`,
    );
  }

  eventoAlterarSimulacao2(idSimulacao: number): Observable<GiFinSimulacaoModel> {
    const url = `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/sse`;

    return new Observable((observer) => {
      let abortController = new AbortController();
      let reconnectTimeout: any;

      const conectar = () => {
        const tokenObj = JSON.parse(localStorage.getItem('token') || '{}');
        const accessToken = tokenObj.accessToken;
        const expirationDate = new Date(tokenObj.expirationDate);
        const msParaExpirar = expirationDate.getTime() - Date.now() - 60 * 1000;

        // Agenda reconexão 60s antes do token expirar
        reconnectTimeout = setTimeout(() => {
          abortController.abort();
          abortController = new AbortController();
          conectar();
        }, msParaExpirar);

        fetch(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: 'text/event-stream',
          },
          signal: abortController.signal,
        })
          .then((response) => {
            if (response.status === 401) {
              clearTimeout(reconnectTimeout);
              console.warn('SSE: token expirado, aguardando renovação...');
              setTimeout(() => conectar(), 5000);
              return;
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            const lerStream = () => {
              reader
                .read()
                .then(({ done, value }) => {
                  if (done) {
                    clearTimeout(reconnectTimeout);
                    observer.complete();
                    return;
                  }

                  const texto = decoder.decode(value, { stream: true });

                  texto.split('\n').forEach((linha) => {
                    if (linha.startsWith('data:')) {
                      const json = linha.replace('data:', '').trim();
                      if (json) {
                        this.zone.run(() => {
                          observer.next(JSON.parse(json) as GiFinSimulacaoModel);
                        });
                      }
                    }
                  });

                  lerStream();
                })
                .catch((erro) => {
                  clearTimeout(reconnectTimeout);
                  if (erro.name === 'AbortError') return;
                  this.zone.run(() => observer.error(erro));
                });
            };

            lerStream();
          })
          .catch((erro) => {
            clearTimeout(reconnectTimeout);
            if (erro.name === 'AbortError') return;
            this.zone.run(() => observer.error(erro));
          });
      };

      conectar();

      // Cancela o fetch e o timeout quando o componente for destruído
      return () => {
        clearTimeout(reconnectTimeout);
        abortController.abort();
      };
    });
  }

  salvarProposta(idSimulacao, idFinanciadora, proposta: FinProposta) {
    return this.http.post<any>(globals.apiUrl + '/api/FinSimulacao/SalvarProposta', {
      idSimulacao,
      idFinanciadora,
      proposta,
    });
  }

  selecionarPropostaV2(idSimulacao: number, idProposta: number): Observable<void> {
    return this.http.patch<void>(
      globals.apiUrl +
        `/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/propostas/${idProposta}/selecionar`,
      {},
    );
  }

  cadastrarPropostaV2(idTarefa, proposta: FinProposta) {
    return this.http.post<any>(
      globals.apiUrl + `/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/propostas`,
      proposta,
    );
  }

  atualizarPropostaV2(idTarefa, proposta: FinProposta) {
    return this.http.put<any>(
      globals.apiUrl + `/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/propostas/${proposta.id}`,
      proposta,
    );
  }

  buscarSumarioSimulacao(idSumario: number): Observable<SumarioSimulacaoResponse> {
    return this.http.get<SumarioSimulacaoResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSumario}/sumario`,
    );
  }

  buscarDetalhesProposta(idOportunidade: number, idProposta: number): Observable<DetalhePropostaResponse> {
    return this.http.get<DetalhePropostaResponse>(
      `${globals.apiUrl}/api/v2/crm/resources/oportunidades/${idOportunidade}/propostas-financiamento/${idProposta}`,
    );
  }

  contratoManual(idProposta: number, idFormulario: number, data: ContratarManualPropostaRequest) {
    return this.http.patch<any>(
      globals.apiUrl +
        `/api/v2/financiamentos/resources/propostas/${idProposta}/contratar/manual/formularios/${idFormulario}`,
      data,
    );
  }

  contratoGateway(idProposta: number, data: ContratarGatewayPropostaRequest) {
    return this.http.patch<any>(
      globals.apiUrl + `/api/v2/financiamentos/resources/propostas/${idProposta}/contratar/gateway`,
      data,
    );
  }

  cancelarProposta(idProposta: number) {
    return this.http.patch<any>(
      globals.apiUrl + `/api/v2/financiamentos/resources/propostas/${idProposta}/cancelar`,
      {},
    );
  }

  buscaSumarioFinanciadoraMeuFinanciamento(idSimulacao: number, id: number): Observable<SumarioFinanciadoraResponse> {
    return this.http.get<SumarioFinanciadoraResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/meus-financiamentos/${idSimulacao}/financiadoras/${id}/sumario`,
    );
  }

  buscaSumarioFinanciadoraCelulaCredito(idTarefa: number, id: number): Observable<SumarioFinanciadoraResponse> {
    return this.http.get<SumarioFinanciadoraResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras/${id}/sumario`,
    );
  }

  excluirProposta(idProposta) {
    return this.http.delete<any>(globals.apiUrl + '/api/FinSimulacao/ExcluirProposta', {
      params: new HttpParams().set('idProposta', idProposta),
    });
  }

  selecionarProposta(idProposta) {
    return this.http.post<FinProposta>(globals.apiUrl + '/api/FinSimulacao/SelecionarProposta', { idProposta });
  }

  salvarOriginacao(idProposta, enviar, originacaoModel, actionSchemaId, originacaoSchema, idFormulario) {
    return this.http.post<any>(globals.apiUrl + '/api/FinSimulacao/SalvarOriginacao', {
      idProposta,
      enviar,
      originacaoModel,
      actionSchemaId,
      originacaoSchema,
      idFormulario,
    });
  }

  simular(idSimulacao, idFinanciadora, valor, valorEntrada) {
    return this.http.post<any>(globals.apiUrl + '/api/FinSimulacao/Simular', {
      idSimulacao,
      idFinanciadora,
      valor,
      valorEntrada,
    });
  }

  buscarAcquireSchemas(idProposta) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarAcquireSchemas', {
      params: new HttpParams().set('idProposta', idProposta),
    });
  }

  buscarFinanciadoraEscolhidaPorSimulacao(queryFilter: IGridifyQuery | null = null): Observable<FinanciadorasResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<FinanciadorasResponse>(globals.apiUrl + '/api/v2/financiamentos/resources/financiadoras', {
      params: params,
    });
  }

  buscarFinanciadoraDaProposta(idProposta) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarFinanciadoraDaProposta', {
      params: new HttpParams().set('idProposta', idProposta),
    });
  }

  buscarEtapaOportunidadeProposta(idProposta) {
    return this.http.get<any>(globals.apiUrl + '/api/FinSimulacao/BuscarEtapaOportunidadeProposta', {
      params: new HttpParams().set('idProposta', idProposta),
    });
  }

  buscarSumarioPropostaV2(idTarefa: number, idProposta: number): Observable<SumarioPropostaResponse> {
    return this.http.get<SumarioPropostaResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/propostas/${idProposta}/sumario`,
    );
  }
}
